export default __webpack_public_path__ + "media/flags/pn-1c9eed3f.svg";